// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_ht","advertCardHeader__actions":"c-a_hu","advertCardHeader__bottomLabel":"c-a_hv"};